function makeSuggestions({
  suggestionsData,
  hideQuickLinks
}) {
  if (!suggestionsData) {
    return undefined;
  }
  return {
    popularTerms: suggestionsData.popularTerms,
    quickLinks: hideQuickLinks ? [] : suggestionsData.quickLinks
  };
}
export default makeSuggestions;